import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderFormComponent } from './order-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteModule } from 'src/app/shared/autocomplete/autocomplete.module';
import { InputModule } from '../../input/input.module';
import { DatepickerInputModule } from '../../datepicker-input/datepicker-input.module';
import { SupplierBuyerSaleDetailsModule } from 'src/app/inventory/components/supplier-buyer-sale-details/supplier-buyer-sale-details.module';



@NgModule({
  declarations: [OrderFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputModule,
    DatepickerInputModule,
    SupplierBuyerSaleDetailsModule
  ],
  exports: [OrderFormComponent]
})
export class OrderFormModule { }
